import { useSnapshot } from 'hooks/use-safe-snapshot';
import { state } from 'state/current-team';

const useCurrentTeam = () => {
    const { team } = useSnapshot(state);

    return team;
};

export { useCurrentTeam };
